import { LDSingleKindContext } from 'launchdarkly-js-client-sdk';
import getConfig from 'next/config';
import { PublicRuntimeConfig } from 'server/configuration';
import { appStorage } from 'utils/appStorage';
import { RolesT } from 'modules/Organizations/constants';
import { HomeBannerProps } from 'modules/Home/Banner/type';
import { createLDContext } from './context';

const config: PublicRuntimeConfig = getConfig().publicRuntimeConfig;

const sdkKey = config.LD_SDK_KEY;
const clientSideID = config.LD_CLIENT_SIDE_ID;

export interface FeatureFlagsType {
  inputManagerSearchResultCountIndicator: boolean;
  'input-viewer-sidebar-ai-assist-panel': boolean;
  'input-viewer-video-track-timeline': boolean;
  'model-creation-huggingface-import': boolean;
  'model-creation-triton-upload': boolean;
  batchPredictModal: boolean;
  'leaderboard-panel': boolean;
  'primary-input-type-app-creation': boolean;
  'upgrade-app-to-universal-workflow-modal-button': boolean;
  'filter-by-input-type': boolean;
  'show-inputs-counts': boolean;
  'annotations-mode': boolean;
  'default-base-workflow-option-for-text': string;
  'default-base-workflow-option-for-image': string;
  changelog: string;
  'documentation-link-lookup': Record<string, string>;
  'inputs-manager-grid-video-controls': boolean;
  'filter-by-status': boolean;
  'filter-by-labeler': boolean;
  'filters-tooltip-text': Record<string, string>;
  'view-annotation-metrics-button': boolean;
  'show-image-mask-annotations': boolean;
  thirdPartyApiKeyAvailableLDFF: boolean;
  autoAnnotationLabelingTaskFF: boolean;
  enableTemplateFeatureLdff: boolean;
  textGenImageUploadLDFF: boolean;
  'hide-similarity-search-for-text': boolean;
  'enable-resource-pricing': boolean;
  'show-go-to-old-task-review-screen-ldff': boolean;
  resourceVersionSelectorFF: boolean;
  resourceVersionSelectorInModelFF: boolean;
  modulePublishing: boolean;
  controlCenter: boolean;
  controlCenterCosts: boolean;
  controlCenterExternal: boolean;
  workflowVersionEvaluation: boolean;
  workflowsV2LDFF: boolean;
  enableNewInputViewerFeatures: boolean;
  hideFeaturedResources: boolean;
  nodePoolsRestrictInstancesLDFF: boolean;
  generateCoverImage: boolean;
  modelPlaygroundLDFF: boolean;
  allowAllPlaygroundModelsLDFF: boolean;
  allowedOrgRolesForControlCenter: Record<string, RolesT[]>;
  'enable-new-labeler-screen': boolean;
  homePageDeployTrendingModelLDFF: boolean;
  'new-explore-page': boolean;
  billingPlans: Record<string, unknown>;
  'enable-vision-model-page': boolean;
  universalSearchLDFF: boolean;
  displayPlaygroundTokenStatLDFF: boolean;
  showPlaygroundModelMethodLDFF: boolean;
  displayVideoTrackingTool: boolean;
  promptSuggestionConfig: { model: string; promptQuery: string; defaultPrompts: string[]; hide: boolean };
  videoMaskGenerationConfig: { APP_ID: string; MODEL_ID: string; MODEL_VERSION_ID: string; USER_OR_ORG_ID: string };
  enableLocalRunnersLDFF: boolean;
  openAICompatibleModelsLDFF: { modelList: string[] };
  smartInsightConfig: { model: string; hide: boolean; headerName: string; accordionTitle: string };
  homeBannerConfig: HomeBannerProps;
  displayNewDeployModelForm: boolean;
  creditsConfig: {
    hide: boolean;
    minCredit: number;
    recommendedCredit: number;
  };
}

export function getLaunchDarklySDKKey() {
  return sdkKey;
}

export function getLaunchDarklyClientSideID() {
  return clientSideID;
}

export function getLDContext(): LDSingleKindContext | undefined {
  const authData = appStorage.get<CF.LocalUserWithOrg | undefined>('authData');
  return createLDContext(authData);
}
